import { useState, useContext, useRef } from 'react';
import { db, timestamp } from "../../../firebase/config";
import { SavedIcon } from "../../../StateManagment/SavedIcon";
import deleteIcon from '../../../images/icons/delete-icon.png'
import Tooltip from '../../common/Tooltip';
import { client } from "../../../hooks/Client";
import uuid from 'react-uuid';
import { useFirestoreGeneralOrderBy } from '../../../firebase/useFirestore';
import useSettings from '../../../hooks/Settings';
import plusButton from '../../../images/icons/plus-icon.png'
import shouldShowMatrixRightColumn from '../../../helpers/questionnaire/shouldShowMatrixRightColumn';
import React from 'react';
import softDeleteDoc from '../../../helpers/softDeleteDoc';
import { Auth } from '../../../StateManagment/Auth';
import IconButton from '../../common/IconButton';

const MatrixOne = ({field, index}) => {
    // Context
    const [saved, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)

    // Hooks
    const {
        PrimaryColor: primaryColor,
        SecundairyColor: secundairyColor,
        TertairyColor: tertiaryColor,
    } = useSettings();
    const colors = [primaryColor, secundairyColor, tertiaryColor];

    // Firestore
    const matrixRows = useFirestoreGeneralOrderBy('MatrixQuestionRows', 'Field', field.ID, 'Position', 'asc')
    const matrixColumns = useFirestoreGeneralOrderBy('MatrixQuestionColumns', 'Field', field.ID, 'Position', 'asc')

    // Helper function to get a random color
    const getRandomColor = () => {
      const randomIndex = Math.floor(Math.random() * colors.length); // Get a random index
      return colors[randomIndex]; // Return the color at that index
    }

    // Add Matrix Row
    const addMatrixRow = () => {

        // Hier stond ButtonClicked(e, 'Toegevoegd'), dat e.target.innerText
        // overschrijft. Op de oude <img> deed dat niets zichtbaars; op de knop
        // die de plusknop nu is, wist het bij Enter/spatie het plus-icoon.
        // AI-CONTEXT: See docs/pitfalls.md#state-event-target-vs-currenttarget

        db.collection('MatrixQuestionRows')
         .doc()
         .set({
             Title: '',
             TitleRight: '',
             Question: field.Question,
             Field: field.ID,
             Compagny: client,
             CompagnyID: client,
             Timestamp: timestamp,
             Position: matrixRows.length + 1,
             ID: uuid(),
             Color: getRandomColor(),
         })
         .then(() => {
             setSaved('flex')
          })
     }
 
     // Add Matrix Column
     const addMatrixColumn = () => {

         // Zie addMatrixRow: ButtonClicked wist hier het plus-icoon zodra de
         // knop met het toetsenbord bediend wordt.

         db.collection('MatrixQuestionColumns')
         .doc()
         .set({
             Title: '',
             Question: field.Question,
             Field: field.ID,
             Compagny: client,
             CompagnyID: client,
             Timestamp: timestamp,
             Position: matrixColumns.length + 1,
             ID: uuid(),
             Color: getRandomColor(),
         })
         .then(() => {
             setSaved('flex')
          })
     }
 
     // Delete Matrix Row
     // Zacht (ADR-008): tot 2026-10-02 hard, waardoor antwoorden met deze RowID
     // hun label en negatieve formulering kwijtraakten.
     // AI-CONTEXT: See docs/pitfalls.md#database-hard-to-soft-delete-leaves-old-orphans
     const deleteMatrixRow = (e) => {
         const docid = e.currentTarget.dataset.docid
         const title = e.currentTarget.dataset.title

         softDeleteDoc({ collection: 'MatrixQuestionRows', docid, authId: auth?.ID, title })
         .then(() => {
             setSaved('flex')
         })
     }
 
     // Delete Matrix Column
     const deleteMatrixColumn = (e) => {
         const docid = e.currentTarget.dataset.docid
 
         softDeleteDoc({ collection: 'MatrixQuestionColumns', docid })
         .then(() => {
             setSaved('flex')
         })
     }
 
        // Edit Matrix Row
     const rowTitleHandler = (e) => {
         const value = e.target.value
         const docid = e.target.dataset.docid
 
         db.collection('MatrixQuestionRows')
         .doc(docid)
         .update({
             Title: value
         })
         .then(() => {
             setSaved('flex')
         })
     }
 
     // Edit Matrix Column
     const columnTitleHandler = (e) => {
         const value = e.target.value
         const docid = e.target.dataset.docid

         db.collection('MatrixQuestionColumns')
         .doc(docid)
         .update({
             Title: value
         })
         .then(() => {
             setSaved('flex')
         })
     }

     // Edit Matrix Row — right-side statement (bipolar matrix)
     const rightTitleHandler = (e) => {
         const value = e.target.value
         const docid = e.target.dataset.docid

         db.collection('MatrixQuestionRows')
         .doc(docid)
         .update({
             TitleRight: value
         })
         .then(() => {
             setSaved('flex')
         })
     }

     // Toggle the optional right-side statement column (semantic differential)
     const bipolarHandler = (e) => {
         db.collection('QuestionnaireFields')
         .doc(field.docid)
         .update({
             MatrixBipolar: e.target.checked
         })
         .then(() => {
             setSaved('flex')
         })
     }

  const bipolar = shouldShowMatrixRightColumn(field)

  return (
    <div id='edit-matrix-container' style={{display: field.Type === 'matrix-one' ? 'block' : 'none'}}>
      <span className="qb-field-label">Matrix</span>
      <div className='add-matrix-container'>
        <div className='add-matrix-item-container'>
          <Tooltip content='Rij toevoegen' top='-60px' width={'25px'}>
            <IconButton icon={plusButton} label='Rij toevoegen' onClick={addMatrixRow} imgClassName='add-matrix-item-icon' />
          </Tooltip>
          <p>Voeg een rij toe</p>
        </div>
        <div className='add-matrix-item-container'>
          <Tooltip content='Kolom toevoegen' top='-60px' width={'25px'}>
            <IconButton icon={plusButton} label='Kolom toevoegen' onClick={addMatrixColumn} imgClassName='add-matrix-item-icon' />
          </Tooltip>
          <p>Voeg een kolom toe</p>
        </div>
      </div>

      <label className='matrix-bipolar-toggle'>
        <input type='checkbox' checked={bipolar} onChange={bipolarHandler} />
        <span>Rij titels rechts tonen</span>
      </label>

   <div
  id="matrix-grid-container"
  style={{
    display: 'grid',
    // first column fixed at 380px; the answer columns flex equally;
    // an optional right-statement column (380px) when bipolar is on
    gridTemplateColumns: `380px repeat(${matrixColumns && matrixColumns.length}, 1fr)${bipolar ? ' 380px' : ''}`,
    gap: '10px'
  }}
>
  {/* 1) top-left corner (empty) */}
  <div />

  {/* 2) column headers */}
  {matrixColumns && matrixColumns.map(column => (
    <div key={column.ID} className="matrix-grid-header">
      <Tooltip content={column.Title || 'Naam van kolom'} top="-60px">
        <input
          type="text"
          defaultValue={column.Title}
          placeholder="Naam van kolom"
          data-docid={column.docid}
          onChange={columnTitleHandler}
        />
      </Tooltip>
      <Tooltip content={`Verwijder ${column.Title}`} top="-60px">
        <img
          src={deleteIcon}
          className="matrix-delete-icon"
          data-docid={column.docid}
          onClick={deleteMatrixColumn}
          alt=""
        />
      </Tooltip>
    </div>
  ))}

  {/* 2b) top-right corner (empty) when bipolar */}
  {bipolar && <div />}

  {/* 3) each data row: a fragment with 1 header cell + N checkbox cells (+ optional right header) */}
  {matrixRows && matrixRows.map(row => (
    <React.Fragment key={row.ID}>
      <div className="matrix-grid-header">
        <Tooltip content={row.Title || 'Naam van rij'} top="-60px">
          <input
            type="text"
            defaultValue={row.Title}
            placeholder="Naam van rij"
            data-docid={row.docid}
            onChange={rowTitleHandler}
          />
        </Tooltip>
        <Tooltip content={`Verwijder ${row.Title}`} top="-60px">
          <img
            src={deleteIcon}
            className="matrix-delete-icon"
            data-docid={row.docid}
            data-title={row.Title}
            onClick={deleteMatrixRow}
            alt=""
          />
        </Tooltip>
      </div>
      {matrixColumns && matrixColumns.map(col => (
        <div key={col.ID} className="matrix-grid-item">
          <input type="checkbox" />
        </div>
      ))}
      {bipolar && (
        <div className="matrix-grid-header last-column">
          <Tooltip content={row.TitleRight || 'Naam van rij rechts'} top="-60px">
            <input
              type="text"
              defaultValue={row.TitleRight}
              placeholder="Naam van rij rechts"
              data-docid={row.docid}
              onChange={rightTitleHandler}
            />
          </Tooltip>
        </div>
      )}
    </React.Fragment>
  ))}
</div>


  </div>
  )
}

export default MatrixOne